import React from "react";
import InnerBanner from "../components/PagesComponents/InnerBanner";
import MainLayout from "../components/Layouts/MainLayout";

const PrivacyPolicy = () => {
  return (
    <>
      <MainLayout>
        <InnerBanner pageKey="privacyPolicy" />

        <div className="container py-4">
          <p className="mb-3">
            <strong className="fw-bold">
              This Privacy Policy applies to{" "}
              <a href="https://www.tokoyarn.com" className="text-decoration-none text-primary">TokoYarn.com</a>
            </strong>
          </p>
          <p className="mb-3">
            Thanks for using TokoYarn!
          </p>
          <p className="mb-3">
            This privacy policy applies to your use of TokoYarn’s website,
            application, products, and services. TokoYarn recognizes the
            importance of maintaining your privacy. We extremely value your
            privacy and appreciate your trust in us.
          </p>
          <p className="mb-3">
            This Policy describes how we collect and use information we collect on
            https://www.tokoyarn.com and other offline sources, so that you can make
            an informed decision about using the Services. This Privacy Policy
            applies to current and former visitors to our website and to our
            online customers. We will not share your information with anyone
            except as described in this Privacy Policy.
          </p>
          <p className="mb-4">
            This policy does not apply to the practices of organizations that we do
            not own or control, or people we do not employ or manage. Please read
            it carefully before using the services or submitting any information
            to us. If you do not agree to the terms of our Privacy Policy, we request
            you to immediately stop accessing our service.
          </p>

          <h2 className="h4 mb-3">What Information We Collect?</h2>
          <ol className="list-unstyled main-list ps-3">
            <li><strong className="fw-semibold">Usage/Log Information</strong></li>
            <p className="mb-3 ms-4 list-content">
              We collect usage information such as IP address, the web browser
              type, operating system, address of the reference website or the
              website to which you exit, date and time you access our website
              or services, items you click on, pages you visit, and time spent on
              each page.
            </p>
            <li><strong className="fw-semibold">
              Cookies, Other Tracking Technologies, and Online Advertising
            </strong></li>
            <p className="mb-3 ms-4 list-content">
              We also collect certain information (automatically) through the use
              of cookies, web beacons, analytics/webmaster tools, and/or similar
              tracking technologies. We may also use third parties to display and
              target ads, provide certain functionality (such as maps), or to place
              their own cookies and other tracking technologies to collect, track,
              and analyze usage and statistical information from users. We are not
              responsible for the information collection practices of any third
              parties.
            </p>
            <li><strong className="fw-semibold">Personal Information</strong></li>
            <p className="mb-3 ms-4 list-content">
              We collect and store Personal Information that you provide to us
              when accessing or using our Services. “Personal Information” means
              information relating to a person who is or can be identified
              directly from that information. This includes your name, gender,
              address, telephone number, email address, credit card, or other
              account number. Personal Information does not include:
            </p>
            <ol className="list-unstyled sub-list ms-5">
              <li>Aggregated or anonymized information</li>
              <li>
                Any publicly available information about designers/vendors
              </li>
              <li>
                Information about you that is provided by third parties; for example,
                if you use an integrated social media feature on our website, the
                third-party social media site will give us certain information
                about you.
              </li>
            </ol>
            <p className="mb-3">
              Examples of Personal Information we collect include information that
              you provide when you (a) create or update your TokoYarn account, (b)
              communicate with us, (c) purchase services/products from us, (d)
              contact, review, or recommend a designer/vendor, (e) submit client ratings or
              peer endorsements. If you are a designer/vendor and want to update your
              profile (“Profile”), or post information using your Profile, we may
              also collect verification information. We may collect demographic
              information about you, products you like, events you intend to
              participate in, or any other information provided by you during the
              use of our website. We might collect this as a part of a survey
              also.
            </p>
            <p className="mb-3">
              We do not knowingly contact or collect personal information from
              children under 13. If you believe we have inadvertently collected
              such information, please contact us so we can promptly obtain
              parental consent or remove the information.
            </p>
            <li><strong className="fw-semibold">Publicly Posted Information</strong></li>
            <p className="mb-3 ms-4 list-content">
              Personal Information that you post in public areas of our Services
              or via your Profile may become publicly available and is not
              considered Personal Information. For example, information you post
              in your Profile, peer endorsements, Q&A, or any other interactive
              areas may be made publicly available and can potentially be viewed
              by anyone. Your posting to such public areas of the Services
              constitutes consent to share such information publicly, and you
              should assume that such information will be widely disseminated,
              including via search engines and other tools to locate information
              online (e.g., internet archive).
            </p>
          </ol>

          <h2 className="h4 mb-3 mt-4">Use of Your Information</h2>
          <ol className="list-unstyled main-list ps-3">
            <li><strong className="fw-semibold">Non-personal Information</strong></li>
            <p className="mb-3 ms-4 list-content">
              We may use information other than Personal Information, including
              aggregated or anonymous information, for ad targeting, to analyze
              trends, administer our Services, improve customer service, diagnose
              problems with our servers, track user movement, and gather
              demographic information for aggregate use. Third-party ad platforms
              may use this information for a similar purpose, but you should
              follow up with third parties and confirm their information
              collection and usage practices directly. We may publish, disclose,
              and use information other than Personal Information, including
              aggregated or anonymous Personal Information, to or with third
              parties.
            </p>
            <li><strong className="fw-semibold">Personal Information</strong></li>
            <p className="mb-3 ms-4 list-content">
              We use Personal Information to facilitate your use of the Services,
              to process your requests or transactions, to provide you with
              information, products, and services you request, to administer and
              assist us with the operation of our business, and for the purpose
              for which the information was provided. We may use the information
              we collect to send you news relevant to you or in accordance with
              your preferences. We may use information you provide to send you
              about special promotions or offers. We might also tell you about new
              features or products. These might be our own offers or products, or
              third-party offers or products we think you might find interesting.
              We may also send you advertisements from third parties. We will not
              disclose, rent, sell, or otherwise make available your Personal
              Information to third parties for direct marketing purposes.
            </p>
            <li><strong className="fw-semibold">
              Third-Party Service Providers
            </strong></li>
            <p className="mb-3 ms-4 list-content">
              In the event that we engage with third-party service providers in
              connection with our Services, we may share Personal Information with
              such service providers who need access to such information to carry
              out their work for us. For example, we may use credit card
              processing or verification companies to verify credit card
              information or to verify your identity. Other than such service
              providers, we do not share Personal Information with third parties
              unless (1) you have indicated to us that you wish to receive
              information from such parties; (2) you otherwise give us your
              consent to do so; or (3) in response to a request for information or
              a subpoena.
            </p>
            <li><strong className="fw-semibold">Text Messaging</strong></li>
            <p className="mb-3 ms-4 list-content">
              We do not ordinarily send text messages for marketing purposes, but
              to the extent you provide us with your mobile telephone number, you
              consent to the transmission of text messages to such number. You
              may, however, contact us and opt out of receiving such texts.
            </p>
            <li><strong className="fw-semibold">General</strong></li>
            <p className="mb-3 ms-4 list-content">
              We may use information to protect our company, our customers, or our
              websites. We may share information with any successor to all or part
              of our business. For example, if part of our business is sold, we may
              give our customer list as part of that transaction.
            </p>
            <p className="mb-3">
              We may disclose Personal Information when we are required to or we
              believe it is appropriate to comply with the law (e.g., a lawful
              subpoena, warrant, or court order); to enforce or apply this Policy
              or our other policies or agreements; to initiate, render, bill, and
              collect for amounts owed to us; to protect our or our users’ rights,
              property, or safety; to protect our users from fraudulent, abusive,
              or unlawful use of the Services; or if we believe that an emergency
              involving the danger of death or serious physical injury to any
              person requires or justifies disclosure of Personal Information.
              We may also share it if a government agency or investigatory body
              requests or when we are investigating potential fraud.
            </p>
            <p className="mb-3">
              We use information as otherwise permitted by law. We may share your
              information for reasons not described in this policy. We will inform
              you before we do this.
            </p>
            <p className="mb-3">
              We have no obligation to delete any data or information you provide
              on a product description form or anywhere else on the website following
              termination of your account or the account of any designer/vendor to
              whom your product description was submitted through the Site.
              Registered users who wish to close their account should write to{" "}
              <a href="mailto:support@tokoyarn.com" className="text-decoration-none text-primary">support@tokoyarn.com</a>
            </p>
            <p className="mb-4">
              Designers/vendors and their employees should be particularly aware of their
              obligations of client/user confidentiality, both in communicating
              with TokoYarn.com and in consulting users via the site. TokoYarn.com does
              not have, and will not accept, any obligations of confidentiality
              with respect to any communications.
            </p>
          </ol>

          <h2 className="h4 mb-3" style={{ marginTop: "28px" }}>Information Security</h2>
          <p className="mb-3">
            We take reasonable steps to secure your personally identifiable
            information against unauthorized access or disclosure. However, no
            security or encryption method can be guaranteed to protect information
            from hackers or human error.
          </p>

          <article>
            <h2 className="h4 mb-3">Grievance Redressal</h2>
            <p className="mb-3">
              If you have any questions or grievances regarding anything covered
              by this privacy statement, you may contact our Grievance Officer at{" "}
              <a href="mailto:grievance@tokoyarn.com" className="text-decoration-none text-primary"> grievance@tokoyarn.com</a> or write
              to the following address:
            </p>
            {/* Assuming AddressCard will be updated or replaced to reflect TokoYarn's address */}
            <p className="mb-3">
              TokoYarn Grievance Officer <br />
              [Insert TokoYarn Company Address Line 1] <br />
              [Insert TokoYarn Company Address Line 2] <br />
              [Insert TokoYarn Company Address Line 3] <br />
              [Insert TokoYarn Company Address Line 4] <br />
              [Insert TokoYarn Company Address Line 5]
            </p>
            <p className="mb-3">
              If you have any questions or concerns about our privacy policies,
              please send an email to{" "}
              <a href="mailto:support@tokoyarn.com" className="text-decoration-none text-primary">support@tokoyarn.com</a>
            </p>
            <p className="mb-3">
              This privacy policy was last updated on June 16, 2025. Our privacy
              policy may change from time to time. If we make any material changes
              to our policies, we will place a prominent notice on our website or
              application. If the change materially affects registered users, we
              will send a notice to you by email.
            </p>
          </article>
        </div>
      </MainLayout>
    </>
  );
};

export default PrivacyPolicy;